/**
 * Пауза правила после срабатывания (ТЗ №42): cooldown_value (целое >= 1) и
 * cooldown_unit. Выключено — оба поля null.
 */

export const COOLDOWN_UNITS = ['seconds', 'minutes', 'hours', 'days'];

export const COOLDOWN_UNIT_LABELS = {
  seconds: 'Секунды',
  minutes: 'Минуты',
  hours: 'Часы',
  days: 'Дни',
};

const SHORT_UNITS = { seconds: 'с', minutes: 'мин', hours: 'ч', days: 'дн' };

const isFilled = (value) => value !== null && value !== undefined && value !== '';

export const cooldownFromRule = (rule) => {
  const value = rule?.cooldown_value;
  const unit = rule?.cooldown_unit;
  if (!isFilled(value) || !isFilled(unit)) return { enabled: false, value: '', unit: 'minutes' };
  return { enabled: true, value: String(value), unit: String(unit) };
};

export const cooldownToDto = (form) => {
  if (!form?.enabled) return { cooldown_value: null, cooldown_unit: null };
  return { cooldown_value: Number(form.value), cooldown_unit: form.unit };
};

/** Текст ошибки или null. */
export const validateCooldown = (form) => {
  if (!form?.enabled) return null;
  const value = Number(form.value);
  if (!isFilled(form.value) || !Number.isInteger(value) || value < 1) {
    return 'Целое число не меньше 1';
  }
  if (!COOLDOWN_UNITS.includes(form.unit)) return 'Выберите единицу паузы';
  return null;
};

export const formatCooldownShort = (rule) => {
  const value = rule?.cooldown_value;
  const short = SHORT_UNITS[rule?.cooldown_unit];
  if (!isFilled(value) || !short) return '—';
  return `${value} ${short}`;
};
